// 抽奖组件专用语言包 - 繁体中文
export default {
  // Header 相关
  loginBtn: "登入",
  logoutBtn: "登出",
  bindRoleBtn: "綁定角色",
  switchRoleBtn: "切換角色",
  accountLabel: "賬號：",
  joinActivityText: '已有 <span class="number">${n}</span> 人參加活動',

  // ========== 通用錯誤 ==========
  20001: "操作失敗，請檢查後重試",
  21000: "請先登入",

  // ========== 活動狀態相關 ==========
  21026: "活動尚未開始",
  21027: "活動已結束",
  21031: "不在領獎時間範圍內",
  21032: "不在抽獎時間範圍內",

  // ========== 預約相關 ==========
  21028: "請先綁定角色",
  21029: "您已完成預約",
  21030: "尚未參與預約",
  21033: "預約失敗，請稍後再試",

  // ========== 任務相關 ==========
  50001: "任務不存在",
  50002: "任務尚未完成",
  50003: "任務獎勵已領取",
  50004: "領取獎勵失敗，請稍後重試",

  // ========== 積分相關 ==========
  60001: "積分餘額不足",
  60002: "積分扣減失敗",
  60004: "操作繁忙，請稍後重試",
  60006: "操作衝突，請重試",
  60007: "積分增加失敗",

  // ========== 抽獎相關 ==========
  21018: "積分不足",
  21019: "抽獎失敗",
  21022: "活動未結束",
  21023: "無可領取的實物獎勵",
  21024: "領取實物獎勵失敗",
  21025: "提交的資料過長",
  21027: "沒有可領取的虛擬獎勵",
  30102: "今日抽獎次數已達上限",
  30103: "操作過於頻繁，請稍後再試",
  30104: "獎池配置錯誤",
  30105: "獎勵已發放完畢",
  30107: "獎品庫存不足",
  30108: "系統繁忙，請稍後重試",
  30109: "獎池已抽完",

  // ========== 組隊相關 ==========
  30201: "因特定限制無法加入隊伍",
  30202: "因特定限制無法加入隊伍",
  30203: "因特定限制無法加入隊伍",
  30204: "因特定限制無法加入隊伍",
  30205: "因特定限制無法加入隊伍",
  30501: "您已有隊伍，無法重複加入",
  30502: "角色等級不足，需要達到45級",
  30503: "隊伍不存在，請檢查組隊碼",
  30504: "隊伍人數已滿",
  30505: "您已是該隊伍成員",
  30506: "生成組隊碼失敗",
  30507: "創建隊伍失敗",
  30509: "請先綁定角色",
  30510: "角色等級查詢失敗",

  // 成功提示
  claimVirtualRewardSuccess: "請至【我的獎品】頁面查看禮包碼",

  // 通用文案
  commonTip: "請稍後再試",
  confirmBtn: "確認",
  cancelBtn: "取消",
  common: "請稍後再試",

  // 绑定角色相关
  bindPopupTitle: "角色綁定",
  serverTitle: "伺服器",
  roleTitle: "角色名",
  pleaseSelectServer: "請選擇伺服器",
  pleaseSelectRole: "請選擇角色",
  ensure: "確認",
  noNewServerRoleTips: "未查詢到角色，請先前往遊戲創建角色",
  bindFailedTips: "綁定失敗，請重試",
  bindSuccess: "綁定成功",

  // 登录相关
  loginTip: "完成登入即可參與內容創作",
  nowLoginBtn: "立即登入",

  // 规则弹窗
  rulePopupContent: `新版本預約網頁活動現已開放，快來參與得好禮吧~

〓 活動時間 〓
活動參與時間： 2026年3月19日 00:00（UTC+8）至 2026年3月25日 23:59（UTC+8）
獎勵開放領取時間： 2026年3月26日 00:00（UTC+8）至 2026年4月1日 23:59（UTC+8）

〓 參與條件〓
玩家需登入賬號並綁定角色，即可參與活動。
※支持切換角色，但任務完成狀態、所獲獎勵只與賬號相關連，不受切換角色的影響。

〓 預約新版本〓
預約人數突破指定里程碑節點時，全服玩家均可在版本更新後獲得對應的預約獎勵。獎勵將直接發放至玩家的遊戲內信箱。

〓 參與積分任務 〓
玩家必須先完成新版本預約，方可解鎖並參加積分獲取任務，任務詳情請參閱活動頁面。

【組隊集結任務特殊説明】
1.參與條件： 角色等級需≥45級。
2.隊伍限制： 每位玩家僅能綁定一個隊伍；隊伍一旦創建或加入後，不可解散、不可退出；每個隊伍人數上限為 10人。
3.創建隊伍：符合條件的玩家可直接創建隊伍，但隊長無法將隊員踢出隊伍。
4.加入隊伍：玩家可透過輸入他人的組隊碼，或直接點擊組隊連結加入隊伍。
※嚴禁通過創建多個帳號等違規行為參與組隊並刷取獎勵，一經發現將取消領獎資格。

【注意事項】
每日刷新次數的任務將於每日凌晨 00:00 重置進度，前一日未領取的獎勵將無法補發；所有任務獎勵請務必在活動期間內領取，活動結束後將無法補發。

〓 積分抽獎 〓
1.玩家可使用「積分」參與抽獎；每 20 積分可進行1次抽獎，每 200 積分可進行一次「10連抽獎」。
2.積分僅限在 2026年4月1日 23:59 前使用，逾期將自動失效。
3.抽得的獎勵可於「查看我的獎品」頁面確認，並於版本更新後開放領取。

〓 獎勵領取規則 〓
1.領獎時間： 版本更新後至 2026年4月8日 23:59 止。
2.發放形式： 奖励將以「禮包碼」形式在頁面發放，可前往兌換平台或遊戲內兌換。
3.剩餘積分處理： 若帳號內剩餘積分大於 20 分，需先消耗積分進行抽獎，方可領取獎勵。

〓 獎品内容及概率 〓
愛心領寵牌*2（2%）
老舊卡冊*2（3%）
元素結晶寶箱*1（4%）
金幣*888（6%）
精煉自選禮盒*1（10%）
血跡樹枝*1（12%）
馬牌*1（16%）
寵物飼料*5（22%）
冒險幣*10000（25%）

※ 活動最終解釋權歸《RO仙境傳說：世界之旅》遊戲官方所有。官方有權根據活動實際情況，在法律允許範圍內對本規則進行補充、修改或變更，並於官方管道公告後生效。`,

  // ========== 组队邀请相关 ==========
  teamInvite: {
    // 按钮文案
    eventRule: "活動規則",
    createTeam: "創建隊伍",
    breakTeam: "解散隊伍",
    breakDeny: "無法解散",
    exitTeam: "退出隊伍",
    inviteJoinTeam: "邀請好友加入",
    teamNumFull: "隊伍已滿",
    joinOtherTeam: "加入其他隊伍",
    checkTeamInfo: "查看隊伍詳情",
    refresh: "刷新",

    // 奖励状态
    unFinished: "未完成",
    claim: "領取",
    claimed: "已領取",

    // 动态文案
    myTeamNum: "我的隊伍人數：${num}",
    joinSuccess: "成功邀請 ${num} 人加入",
    teamFilledAward: "隊長專屬獎勵（隊伍滿員）",
    awardTitle: "組隊獎勵",

    // 提示文案
    breakDenyTips: "隊伍有其他成員，無法解散",
    ruleDissolve: "隊伍有其他成員時無法解散，請先讓成員退出",
    teamExitDenyTips: "當前無法退出隊伍",
    teamCreated: "隊伍創建成功",
    teamBreak: "隊伍已解散",
    teamExit: "已退出隊伍",
    inviteSuccess: "邀請鏈接已生成",
    refreshSuccess: "刷新成功",
    claimSuccess: "領取成功",

    // 角色
    captain: "隊長",
    member: "隊員",
  },
};
